import {
	AavoArrayFieldItemButtonsTemplate,
	AavoArrayFieldItemTemplate,
	AavoArrayFieldTemplate,
	AavoCheckboxWidget,
	AavoDateTimeWidget,
	AavoDateWidget,
	AavoEmailWidget,
	AavoFieldTemplate,
	AavoObjectFieldTemplate,
	AavoPasswordWidget,
	AavoSelectWidget,
	AavoTextareaWidget,
	AavoTextWidget,
	AavoUrlWidget,
} from "src/components/common/forms/jsonSchema/aavoJsonSchemaThemeComponents.tsx";

export const aavoJsonSchemaWidgets = {
	TextWidget: AavoTextWidget,
	TextareaWidget: AavoTextareaWidget,
	PasswordWidget: AavoPasswordWidget,
	EmailWidget: AavoEmailWidget,
	URLWidget: AavoUrlWidget,
	UpDownWidget: AavoTextWidget,
	SelectWidget: AavoSelectWidget,
	CheckboxWidget: AavoCheckboxWidget,
	DateWidget: AavoDateWidget,
	DateTimeWidget: AavoDateTimeWidget,
};

export const aavoJsonSchemaTemplates = {
	FieldTemplate: AavoFieldTemplate,
	ObjectFieldTemplate: AavoObjectFieldTemplate,
	ArrayFieldTemplate: AavoArrayFieldTemplate,
	ArrayFieldItemTemplate: AavoArrayFieldItemTemplate,
	ArrayFieldItemButtonsTemplate: AavoArrayFieldItemButtonsTemplate,
};
